<div>
  <div width="4" height="26" fill="#F7F7FB" fill-opacity="0.96"></div>
  <div width="4" height="12" fill="#F7F7FB" fill-opacity="0.96"></div>
  <div width="4" height="4" fill="#F7F7FB" fill-opacity="0.96"></div>
</div>
